import axios  from 'axios'

export const isDev = process.env.VUE_APP_MODE === 'test' 
export const devhost = "ks.rrxue.cn"
// export const devhost = "xuelu0829.1818w.cn"

axios.interceptors.request.use(function (config) {
    let token = localStorage.getItem("usertoken");
    var host = window.location.host;
    // host = "wx.zljykj.net";
    if (token == undefined) {
        // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjI4OTY0NDEzLCJ1c2VybmFtZSI6InluaHIyNDg1NzAwNzYzIn0.w6onsN0h-p3aUs00cHcbPTEkUt0qc2eafP_KALkncno";
        token = "";
    }
    if(process.env.NODE_ENV === 'development') {
        host = devhost
        token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjI4OTY0NDEzLCJ1c2VybmFtZSI6InluaHIyNDg1NzAwNzYzIn0.w6onsN0h-p3aUs00cHcbPTEkUt0qc2eafP_KALkncno'
    }
    config.params = {
        host: host,
        token: token,
        ...config.params
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

export const uri = isDev ? 'http://192.168.0.164' : 'https://uapi.233.com';
// export const uri = 'http://192.168.0.164';

export const getEvaluateByTeacher = (params,callback) => get('/Course/Evaluate/GetEvaluateByTeacher',params,callback);//根据老师获取评价

export const getAllCourse = (params,callback) => get('/Course/Course/GetAllCourse',params,callback);//获取全部班级

export const getUnionConfig = (params,callback) => get('/UnionInfo/Info/GetPuConfig',params,callback);//配置

export const getVideoCourse = (params,callback) => get('/Course/Course/GetVideoCourse',params,callback);//获取视频播放器的章节

export const getClassComparison = (params,callback) => get('/Course/Course/GetClassComparison',params,callback);//获取班级对比数据

export const getMemberPicpath = (params, callback) => get('/Member/Info/GetMemberPicpath', params, callback);//获取用户头像

export const getBook = (params, callback) => get('/Course/Course/GetBook', params, callback);//获取赠送书籍信息

export const Statistics = (params, callback) => get('/UnionInfo/Info/Statistics', params, callback) // cnzz


export  const  get =  (api,params,callback) =>  axios.get(uri+api,{
    params:params
}).then(res => {
    callback(res.data);
});

export  const post =  (api,params,callback) =>  axios.post(uri+api,params)
.then(res =>{
    callback(res.data);
});
